module.exports = __webpack_public_path__ + "static/media/p3.75f0db71.jpg";